import moment from 'moment';
import React from 'react';

const RestrictedInfo = ({ item, viewType = 'block-view' }) => {
	if (!item?.isReserved) return null;

	return (
		<div className={`restricted-box ${viewType}`}>
			<span className="status red-1 gray_dark_01">
				Restricted{item?.reservationDays ? `: ${item.reservationDays} days` : ''}
			</span>
			<div className={`date ${viewType !== 'inline-view' ? 'mt-1' : ''}`}>
				<ul className={`common-list-component ${viewType !== 'inline-view' ? 'mt-1' : ''}`}>
					{item?.reservationEndDate && (
						<li>
							<span>
								Till {moment(item.reservationEndDate, 'YYYY-MM-DD').format('DD MMM, YY')}{' '}
							</span>
						</li>
					)}
					{item?.reservedFor && (
						<li>
							For:
							<span className="gray_dark_01"> {item.reservedFor}</span>
						</li>
					)}
				</ul>
			</div>
		</div>
	);
};

export default RestrictedInfo;
